import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../classes/tradePlan/tradePlanProvider';
import { RefactoredChartContainer } from '../../../../charts/d3/candlestickchart/newCandleChart/chartContainer/RefactoredChartContainer';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import {
  mapAccountsFromBalances,
  resolveMarketDataBrokerage,
} from '../../../../../../utils/accountRouting';
import { getDefaultLiveSessionConfig } from '../../../../../../utils/marketSession';

type Props = {
  numberOfCandles: number;
  timeUnit: string;
  candleDuration: number;
  id: string;
  showCandleNumbers: boolean;
  autoSend: boolean;
};

export const TradingChart = observer(
  ({
    autoSend,
    numberOfCandles,
    timeUnit,
    candleDuration,
    id,
    showCandleNumbers,
  }: Props) => {
    const tradePlanForm: TradePlanData = useTradePlanFormStore();
    const { accountBalanceStore } = useWebsocketStore();
    const defaultSession = getDefaultLiveSessionConfig();
    const accounts = mapAccountsFromBalances(accountBalanceStore?.balances);
    const marketDataBrokerage = resolveMarketDataBrokerage({
      accountNumber: tradePlanForm.accountNumber,
      accounts,
      currentBrokerage: tradePlanForm.brokerage,
      dataSource: tradePlanForm.dataSource,
      symbol: tradePlanForm.symbol,
    });

    const size = 362;
    return (
      <div style={{ padding: '5px' }}>
        <RefactoredChartContainer
          autoSend={autoSend}
          tradePlanId="newTradePlan"
          symbol={tradePlanForm.symbol}
          dataSource={tradePlanForm.dataSource}
          brokerage={marketDataBrokerage}
          accountNumber={tradePlanForm.accountNumber}
          numberOfCandles={numberOfCandles}
          timeUnit={timeUnit}
          candleDuration={candleDuration}
          id={id}
          size={size}
          margin={4}
          showCandleNumbers={showCandleNumbers}
          startHour={tradePlanForm.startHour ?? defaultSession.startHour}
          startMin={tradePlanForm.startMin ?? defaultSession.startMin}
        />
      </div>
    );
  }
);
